<template>
  <div :style="themeColor" class="sub-heading items">
      <div class="clearfix">
          <div class="left">
              <p class="text-large amount">
                {{total}}
                <span class="single-item-tax" id="single-item-tax"> + taxes extra</span>

              </p>
              <p class="text-large package-name">
                {{item.name}}
              </p>
          </div>
          <div class="right">
              <div class="relative">
                <select class="quantity" id="quantity" v-model.number="item.quantity" >
                    <option v-for="qty in 10" :value="qty">
                      {{ displayQty(qty) }}
                    </option>
                </select>
                <!-- <label for="quantity"></label> -->
              </div>
              <a href="#" class="remove-item"></a>
          </div>
      </div>
      <p class="description">
        {{item.description}}
      </p>
  </div>
</template>

<script>
export default {
  name: 'line-item-single',
  props: {
    item: {}
  },
  computed: {
    total() {
      return this.item && this.item.displayTotal();
    },

  },
  methods: {
    displayQty(qty) {
      return "Qty " + qty;
    }
  }
}
</script>


// WEBPACK FOOTER //
// SingleLineItem.vue?16fe3f56